export default {
  common: {
    navTitle: 'Complete paperwork',
    patientInfo: 'Patient information',
    guardianInformation: 'Guardian information',
    contactInformation: 'Contact information',
    employerInformation: 'Employer information',
    insuranceInformation: 'Insurance information',
    primaryInsurance: 'Primary insurance',
    secondaryInsurance: 'Secondary insurance',
    emergencyContact: 'Emergency contact',
    additionalInformation: 'Additional information',
    consentForms: 'Consent forms',
    photoId: 'Photo ID',
  },
  patientInfo: {
    subtitle:
      'We need a few more details to help the provider deliver the highest quality of care during your visit.',
  },
  complete: {
    returnToAccount: 'Return to account',
    noThanks: 'No thanks, not right now',
    viewWaitlist: 'View live waitlist',
    viewVisitDetails: 'View visit details',
    paperworkReceived: 'The clinic has received your paperwork.',
    returnTablet: 'Please return the tablet to the front desk',
    allSet: "You're all set!",
    edit: 'Edit paperwork',
    upsell: {
      title: 'Maximize your health benefits',
      trackSpending: 'Track your spending, see hidden perks',
      costEstimates: 'and get cost estimates for your care.',
      viewMyBenefits: 'View my benefits',
    },
  },
  consent: {
    title: 'Review and sign forms',
    subtitle: 'Please review the attached documents and add your digital signature below.',
    addSignature: 'Tap to add signature',
    agreementCopy:
      'By continuing, I understand and agree to the terms and conditions contained in the forms above and agree to sign them electronically.',
    htmlTitle: 'Paperwork – Consent',
    error: {
      message: 'Please see the front desk to sign your forms.',
    },
    updateToView: 'Please update your app to view this file',
  },
  customPaperwork: {
    title: 'Paperwork – Additional Questions',
  },
  finalize: {
    htmlTitle: 'Paperwork – Finalize',
    title: 'Review and submit',
    subtitle:
      'Review and confirm all the details below. If everything looks good, we’ll send to the provider.',
    submit: 'Submit paperwork',
    prefixes: {
      patient: 'Patient',
      emergencyContact: 'Emergency Contact',
    },
    photoId: {
      onFile: 'On file',
      none: 'None',
    },
  },
  start: {
    loading: 'Loading your paperwork',
    edit: {
      cta: 'Edit paperwork',
      subtitleGeneric: 'Thanks for completing paperwork',
      subtitlePersonal: "Thanks for completing {{name}}'s paperwork",
      makeChanges: 'You can make any needed changes to your paperwork here.',
    },
    begin: {
      titlePersonal: "Complete {{name}}'s paperwork",
      titleGeneric: 'Complete paperwork',
      subtitle: 'We need a few details to get you the proper care.',
      loginToGoFaster: "If you've used Solv before, log in to make this part go even faster.",
      cta: 'Start paperwork',
      login: 'Log in with mobile number',
      dontLogin: 'Continue as new patient',
    },
  },
  standardFields: {
    patientFirstName: 'First Name',
    patientMiddleName: 'Middle Name',
    patientLastName: 'Last Name',
    birthDate: 'Birth Date',
    patientGender: 'Gender',
    ethnicity: 'Ethnicity',
    race: 'Race',
    patientAddressStreet: 'Street Address',
    patientAddressStreetTwo: 'Address Line 2',
    patientAddressCity: 'City',
    patientAddressState: 'State',
    patientAddressZip: 'Zip Code',
    primaryPhone: 'Primary Phone',
    email: 'Email',
    reasonForVisit: 'Reason for Visit',
    physician: 'Primary Care Physician',
    pharmacy: 'Preferred Pharmacy',
    howHearAboutUs: 'How did you hear about us?',
    workRelatedInjuryCheck: 'Is this a work related injury?',
    employer: 'Employer',
    selfPayCheck: 'Pay with insurance?',
    insuranceCompany: 'Insurance Company',
    memberId: 'Member ID',
    groupNumber: 'Group Number',
    policyHolderFirstName: 'Policy Holder First Name',
    policyHolderMiddleName: 'Policy Holder Middle Name',
    policyHolderLastName: 'Policy Holder Last Name',
    policyHolderBirthDate: 'Policy Holder Birth Date',
    guardianSameAsSubscriberCheck: 'Same as subscriber?',
    guardianFirstName: 'First Name',
    guardianMiddleName: 'Middle Name',
    guardianLastName: 'Last Name',
    guardianBirthDate: 'Birth Date',
    relationshipToPatient: 'Relationship to Account',
    guardianAddress: 'Address',
    guardianPhone: 'Phone',
    altGuardianPhone: 'Alternate Phone',
    guardianEmail: 'Email Address',
    emergencyContactSameAsGuardianCheck: 'Same as guardian?',
    emergencyContactFirstName: 'First Name',
    emergencyContactMiddleName: 'Middle Name',
    emergencyContactLastName: 'Last Name',
    emergencyContactPhone: 'Phone',
    emergencyContactRelationshipToPatient: 'Relationship to Patient',
    workInjuryEmployerContactName: 'Employer Contact Name',
    workInjuryEmployerContactPhoneNumber: 'Employer Contact Phone Number',
    workInjuryDateOfInjury: 'Date of Injury',
    ssn: 'Social Security Number',
    maritalStatus: 'Marital Status',
    areYouBeingTreatedAtTheRequestOfYourEmployer: 'Are you here at the request of your employer?',
    whatAreYouHereFor: 'What are you here for?',
    whatTypeOfPhysical: 'What type of physical?',
    whatTypeOfDrugScreenAlcoholTest: 'What type of Drug Screen and/or Alcohol Test?',
    howDidYourInjuryOccur: 'How did your injury occur?',
    whenDidYourInjuryOccur: 'When did your injury occur?',
    toWhomReportedYourInjury: 'To whom did you report your injury, if anyone?',
    whereWasPriorTreatment: 'If you received prior treatment, where was it?',
    doYouHaveSecondInsuranceInformation:
      'Do you have secondary insurance information you would like to add?',
    doYouHaveSecondInsuranceInformationMobile: 'Do you have secondary insurance?',
    secondaryInsuranceCompany: 'Insurance company',
    secondaryMemberId: 'Member ID',
    secondaryGroupNumber: 'Group Number',
    secondaryPolicyHolderFirstName: 'Policy Holder First Name',
    secondaryPolicyHolderMiddleName: 'Policy Holder Middle Name',
    secondaryPolicyHolderLastName: 'Policy Holder Last Name',
    secondaryPolicyHolderBirthDate: 'Policy Holder Birth Date',
    customEmployer: 'Employer',
    patientBirthSex: 'Patient Sex',
    policyHolderBirthSex: 'Policy Holder Birth Sex',
    patientsRelationshipToInsured: 'Patient’s Relationship to Insured',
    secondaryPatientsRelationshipToInsured: 'Patient’s Relationship to Insured',
    legalTreatment: 'Legal {{field}}',
    insurancePlanName: 'Insurance Plan',
    frontOfId: 'Front of ID',
    backOfId: 'Back of ID',
  },
  responses: {
    '': '',
    Male: 'Male',
    Female: 'Female',
    Other: 'Other',
    'Transgender Woman/Transgender Female': 'Transgender Woman/Transgender Female',
    'Transgender Man/Transgender Male': 'Transgender Man/Transgender Male',
    'Chose not to disclose': 'Chose not to disclose',
    Unknown: 'Unknown',
    'Hispanic/Latino': 'Hispanic/Latino',
    'Not Hispanic/Latino': 'Not Hispanic/Latino',
    'Prefer not to answer': 'Prefer not to answer',
    'American Indian or Alaska Native': 'American Indian or Alaska Native',
    Asian: 'Asian',
    'Black or African American': 'Black or African American',
    'Hawaiian or Pacific Islander': 'Hawaiian or Pacific Islander',
    White: 'White',
    Solv: 'Solv',
    'Community Event': 'Community Event',
    'School Event/Promotion': 'School Event/Promotion',
    Pediatrician: 'Pediatrician',
    'Flu Shot Clinic': 'Flu Shot Clinic',
    'Billboard/Mailer': 'Billboard/Mailer',
    'Google/Internet': 'Google/Internet',
    Facebook: 'Facebook',
    'Shopping Center': 'Shopping Center',
    Friend: 'Friend',
    'Other/Return': 'Other/Return',
    Yes: 'Yes',
    No: 'No',
    Single: 'Single',
    Married: 'Married',
    Divorced: 'Divorced',
    Widowed: 'Widowed',
    Separated: 'Separated',
    Physical: 'Physical',
    'Drug Screen and/or Alcohol Test': 'Drug Screen and/or Alcohol Test',
    'Work Injury': 'Work Injury',
    DOT: 'DOT',
    'Pre-Employment': 'Pre-Employment',
    Wellness: 'Wellness',
    'Fit for Duty': 'Fit for Duty',
    other: 'other',
    'Post-Accident': 'Post-Accident',
    Random: 'Random',
    'Reasonable Suspicion': 'Reasonable Suspicion',
    Sibling: 'Sibling',
    Child: 'Child',
    Employee: 'Employee',
    Father: 'Father',
    Grandchild: 'Grandchild',
    Grandparent: 'Grandparent',
    Mother: 'Mother',
    'Other Relationship': 'Other Relationship',
    Self: 'Self',
    Spouse: 'Spouse',
  },
  photoId: {
    title: "Add photos of the patient's ID",
    subtitle:
      'The provider needs to verify the patient’s identity with photos of their government-issued ID.',
    guardian: {
      title: "Add photos of the guardian's ID",
      subtitle:
        'The provider needs to verify the guardian’s identity with photos of their government-issued ID.',
    },
    back: {
      title: 'Now, let’s do the back of the ID',
    },
    howDoesItLook: 'How does it look?',
    instructions: {
      title: 'When taking a photo, make sure the ID...',
      isFlat: 'Is lying flat and centered in the camera view.',
      wellLit: 'Is well lit with minimal glare on the surface.',
    },
    ctas: {
      addFrontPhoto: 'Add front photo',
      addBackPhoto: 'Add back photo',
      looksGood: 'Looks good',
      retakeFront: 'Retake front photo',
      retakeBack: 'Retake back photo',
    },
    dragAndDrop: 'or drag and drop file',
  },
};
